import React, { useState } from 'react';
//css
import './PaymentTimeline.css';
//components
import TimelineElement from '../TimelineElement/TimelineElement';

export default function PaymentTimeline({ timelines }) {
    const timelinesLength = timelines.length;
    const [showMoreButton, setShowMoreButton] = useState(timelinesLength > 2);
    const [showMoreContent, setShowMoreContent] = useState(false);
    const handleMoreButtonClick = () => {
        setShowMoreButton(false);
        setShowMoreContent(true);
    }

    return (
        <div className='payment-timeline'>
            <h3>Timeline</h3>
            {timelines.map((timeline, index) => {
                if (index === (timelinesLength - 1)) {
                    timeline = [...timeline, { "operationType": "STARTED" }]
                }
                return (
                    <span key={index}>
                        {index <= 1 && <div><div className={`timeline${index}`}></div><TimelineElement timeline={timeline} parentIndex={index} /></div>}
                        {index > 1 && showMoreContent && <div><div className={`timeline${index}`}></div><TimelineElement timeline={timeline} parentIndex={index} /> </div>}
                    </span>
                )
            })}
            {showMoreButton && !showMoreContent && <div className='more-button-container'>
                <button className='more-button' onClick={handleMoreButtonClick}>More</button>
            </div>}
        </div>
    )
}